import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import About from './pages/About'
import Programs from './pages/Programs'
import Theology from './pages/programs/Theology'
import Leadership from './pages/programs/Leadership'
import Nursing from './pages/programs/Nursing'
import MusicMinistry from './pages/programs/MusicMinistry'
import ConstructionManagement from './pages/programs/ConstructionManagement'
import FoundersCorner from './pages/FoundersCorner'
import Admissions from './pages/Admissions'
import Testimonials from './pages/Testimonials'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'

function App() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      {!isAdminRoute && <Header />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/theology" element={<Theology />} />
          <Route path="/programs/leadership" element={<Leadership />} />
          <Route path="/programs/nursing" element={<Nursing />} />
          <Route path="/programs/music-ministry" element={<MusicMinistry />} />
          <Route path="/programs/construction-management" element={<ConstructionManagement />} />
          <Route path="/founders-corner" element={<FoundersCorner />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  )
}

export default App
